import { useStore as t } from "zustand";
import { useShallow as e } from "zustand/react/shallow";
function n(n) {
  var r = n;
  return r.use = {}, Object.keys(r.getState()).forEach(function (n) {
    var o = function (t) {
      return t[n];
    };
    r.use[n] = "function" == typeof r ? function () {
      return r(e(o));
    } : function () {
      return t(r, e(o));
    };
  }), n;
}
function r(n) {
  var r = n;
  return Object.keys(r.getState()).forEach(function (n) {
    var o,
      u = function (t) {
        return t[n];
      };
    r["use".concat((o = n, o.charAt(0).toUpperCase() + o.slice(1)))] = "function" == typeof r ? function () {
      return r(e(u));
    } : function () {
      return t(r, e(u));
    };
  }), r;
}
export { n as createSelectorFunctions, r as createSelectorHooks };